var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFamily48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7435 24.0588C17.6866 24.0588 20.0724 21.6729 20.0724 18.7298C20.0724 15.7867 17.6866 13.4009 14.7435 13.4009C11.8004 13.4009 9.41455 15.7867 9.41455 18.7298C9.41455 21.6729 11.8004 24.0588 14.7435 24.0588Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7434 24.0586C19.1581 24.0586 22.7368 28.035 22.7368 32.9402V41.8218H7.63816C7.14764 41.8218 6.75 41.4241 6.75 40.9336V32.9402C6.75 28.035 10.3288 24.0586 14.7434 24.0586Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6185 19.6178C35.0521 19.6178 37.8356 16.8343 37.8356 13.4007C37.8356 9.96709 35.0521 7.18359 31.6185 7.18359C28.1849 7.18359 25.4014 9.96709 25.4014 13.4007C25.4014 16.8343 28.1849 19.6178 31.6185 19.6178Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6184 19.6177C36.5236 19.6177 40.5 24.5882 40.5 30.7196V40.9335C40.5 41.424 40.1023 41.8216 39.6118 41.8216H22.7368V30.7196C22.7368 24.5882 26.7132 19.6177 31.6184 19.6177Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFamily48);
export default __webpack_public_path__ + "static/media/pictogramBeaconFamily48.374f5aa19ad4cd7655ceae9908aad00b.svg";
export { ForwardRef as ReactComponent };